import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$stateProvider',
  function (runtimeConstant, $stateProvider) {
    function run() {
      try {
        $stateProvider
          .state('modules', {
            abstract: true,
            url: '/admin',
            templateUrl: 'views/common/admin.html',
            controller: 'adminController',
          })
          .state('viewIntegration', {
            url: '/view/:rev/?t=:token',
            views: {
              '': {
                templateUrl: '/views/viewer.html',
                controller: 'viewerController',
              },
            },
          })
          .state('viewComplete', {
            url: '/view/:rev/:ext?w=:workflow&o:isOldRevision',
            views: {
              '': {
                templateUrl: '/views/viewer.html',
                controller: 'viewerController',
              },
            },
          })
          .state('viewOptional', {
            url: '/view/:rev',
            views: {
              '': {
                templateUrl: '/views/viewer.html',
                controller: 'viewerController',
              },
            },
          })
          .state('publicView', {
            url: '/public/view/:guid',
            views: {
              '': {
                templateUrl: '/views/viewer.html',
                controller: 'viewerController',
              },
            },
          })
          .state('autologin', {
            url: '/login/autologin/:code',
            controller: 'loginController',
            templateUrl: '/views/autologin.html',
          })
          .state('login', {
            url: '/login?redirectUrl=:url',
            data: {
              pageTitle: 'Login',
              specialClass: 'login-content',
            },
            controller: 'loginController',
            templateUrl: '/views/login.html',
          })
          .state('recoverPassword', {
            url: '/recoverPassword?token',
            data: {
              pageTitle: 'RecoverPassword',
              specialClass: 'login-content',
            },
            controller: 'recoverPasswordController',
            templateUrl: '/views/recoverPassword.html',
          })
          .state('requestPasswordInfo', {
            url: '/requestPasswordInfo',
            data: {
              pageTitle: 'RequestPasswordInfo',
              specialClass: 'login-content',
            },
            templateUrl: '/views/requestPasswordInfo.html',
          })
          .state('forgotPassword', {
            url: '/forgotPassword?email',
            data: {
              pageTitle: 'ForgotPassword',
              specialClass: 'login-content',
            },
            controller: 'forgotPasswordController',
            templateUrl: '/views/forgotPassword.html',
          })
          .state('404', {
            url: '/NotFound',
            templateUrl: 'views/404.html',
            data: {
              pageTitle: '404',
              specialClass: 'four-zero-content',
            },
          })
          .state('revisionNotFound', {
            url: '/notfound',
            templateUrl: '/views/404.html',
            data: {
              pageTitle: '404',
              specialClass: 'four-zero-content',
            },
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
